var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('p',[_vm._v("Could not find "+_vm._s(_vm.path))])])}
var staticRenderFns = []

export { render, staticRenderFns }